module.exports = __webpack_public_path__ + "2db8084d412ede1d9ccb5eef1f413c94.png";